import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OpcionEjercicio } from '../../services/catalogos-historico.service';

/**
 * Lista de ejercicios con búsqueda, orden y multiselección (consecutivos o no) para la asignación a varios ejercicios.
 * Muestra el año del ejercicio y marca el vigente (`active = 1`); no asume que el año natural sea el vigente. La selección la posee
 * el padre (`seleccion`) y se emite ordenada de menor a mayor id en cada cambio.
 */
@Component({
  selector: 'app-selector-ejercicios',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './selector-ejercicios.component.html'
})
export class SelectorEjerciciosComponent {
  @Input({ required: true }) ejercicios: OpcionEjercicio[] = [];
  @Input() seleccion: number[] = [];
  @Input() cargando = false;
  @Input() error = '';
  @Input() deshabilitado = false;
  @Output() seleccionChange = new EventEmitter<number[]>();
  @Output() reintentar = new EventEmitter<void>();

  texto = '';
  masRecientesPrimero = true;
  desde: number | null = null;
  hasta: number | null = null;

  get visibles(): OpcionEjercicio[] {
    const buscado = this.texto.trim();
    return this.ejercicios
      .filter(e => !buscado || String(e.anyo).includes(buscado))
      .sort((a, b) => (this.masRecientesPrimero ? b.anyo - a.anyo : a.anyo - b.anyo));
  }

  estaSeleccionado(id: number): boolean { return this.seleccion.includes(id); }

  private emitir(ids: Iterable<number>): void {
    this.seleccionChange.emit([...new Set(ids)].sort((a, b) => a - b));
  }

  alternar(id: number): void {
    if (this.deshabilitado) return;
    this.emitir(this.estaSeleccionado(id) ? this.seleccion.filter(x => x !== id) : [...this.seleccion, id]);
  }

  seleccionarVisibles(): void {
    if (!this.deshabilitado) this.emitir([...this.seleccion, ...this.visibles.map(e => e.id)]);
  }

  limpiar(): void {
    if (!this.deshabilitado) this.emitir([]);
  }

  /** Añade los ejercicios cuyo año está entre «desde» y «hasta» (ambos incluidos), sin quitar los ya elegidos. */
  anadirRango(): void {
    if (this.deshabilitado || this.desde === null || this.hasta === null) return;
    const [min, max] = this.desde <= this.hasta ? [this.desde, this.hasta] : [this.hasta, this.desde];
    this.emitir([...this.seleccion, ...this.ejercicios.filter(e => e.anyo >= min && e.anyo <= max).map(e => e.id)]);
  }

  get resumen(): string {
    const anios = this.ejercicios.filter(e => this.estaSeleccionado(e.id)).map(e => e.anyo).sort((a, b) => a - b);
    return anios.join(', ');
  }
}
